import styled from 'styled-components';

import { MOBILE } from '@/nova/theme/tokens';

/**
 * The demo clip's frame. On desktop it stretches to FILL its half of the showcase (both
 * width and height, via flex); on mobile it goes full-width at a fixed aspect. The clip
 * letterboxes against the (black) showcase section, so it reads as filling the space with
 * no visible box edge. Its size tracks the layout, NOT the clip, so source swaps never
 * reflow it.
 */
export const Frame = styled.div`
  position: relative;
  flex: 1;
  align-self: stretch;
  min-width: 0;
  overflow: hidden;

  ${MOBILE} {
    flex: 0 0 auto;
    width: 100%;
    align-self: auto;
    aspect-ratio: 4 / 5;
  }
`;

/** Holds the cached <video> element (appended imperatively); fills the frame. */
export const Slot = styled.div`
  position: absolute;
  inset: 0;
`;

export const FallbackLayer = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
